import { forwardRef } from 'react';
import type { Dispatch, SetStateAction } from 'react';

// Icon
import Icon from '@/components/base/Icon';
import Input from '@/components/base/Input';
import type { InputProps } from '@/components/base/Input';

export type DatepickerInputProps = Pick<
    InputProps,
    'noBorder' | 'noBorderShadow' | 'placeholder'
> & {
    toggleDatepicker: () => Promise<void>;
    setReferenceElement: Dispatch<SetStateAction<HTMLButtonElement>>;
    isLeftIcon?: boolean;
};

const DatepickerInput = forwardRef<HTMLInputElement, DatepickerInputProps>(
    (
        {
            toggleDatepicker,
            setReferenceElement,
            isLeftIcon,
            placeholder,
            noBorder = true,
            noBorderShadow = false
        },
        ref
    ) => {
        return (
            <button
                ref={setReferenceElement}
                type="button"
                className="w-full border-none focus-within:outline-none focus-within:ring-2 focus-within:ring-icoBlue-200 focus-within:ring-offset-0"
                onClick={toggleDatepicker}>
                <Input
                    ref={ref}
                    readOnly
                    noBorder={noBorder}
                    data-testid="datepicker-input"
                    id="datepicker"
                    noBorderShadow={noBorderShadow}
                    placeholder={placeholder}
                    className="cursor-pointer"
                    inputStyle="datepicker"
                    beforeInput={
                        isLeftIcon ? (
                            <div className="leading-none">
                                <Icon
                                    icon="calendar"
                                    className="text-base text-icoGray-500 dark:text-icoDarkMode-wolf"
                                />
                            </div>
                        ) : null
                    }
                    afterInput={
                        <div className="leading-none">
                            <Icon
                                icon="chevron-bottom"
                                className="align-middle text-base text-icoGray-500 dark:text-icoDarkMode-wolf"
                            />
                        </div>
                    }
                />
            </button>
        );
    }
);

DatepickerInput.displayName = 'DatepickerInput';

export default DatepickerInput;
